module.exports = __webpack_public_path__ + "static/assets/88e5846382b71fc35603553836b9f24e.png";